var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.132,
    height: 186.844,
    viewBox: "0 0 211.132 186.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48385",
    "data-name": "Group 48385",
    transform: "translate(-85.819 -44.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94731",
    "data-name": "Path 94731",
    d: "M76.629,0A76.629,76.629,0,1,1,0,76.629,76.629,76.629,0,0,1,76.629,0Z",
    transform: "translate(115.762 44.334)",
    fill: "#ddf3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94722",
    "data-name": "Path 94722",
    d: "M296.951,171.487v-8.9a6.4,6.4,0,0,0-6.4-6.4H267.964a6.4,6.4,0,0,1-6.4-6.4v-8.9a6.4,6.4,0,0,1,6.4-6.4h.713a6.4,6.4,0,0,0,6.4-6.4v-8.9a6.4,6.4,0,0,0-6.4-6.4H120.1a6.4,6.4,0,0,0-6.4,6.4v8.9a6.4,6.4,0,0,0,6.4,6.4h0a6.4,6.4,0,0,1,6.4,6.4v8.9a6.4,6.4,0,0,1-6.4,6.4H95.357a6.4,6.4,0,0,0-6.4,6.4v8.9a6.4,6.4,0,0,0,6.4,6.4h9.71a6.4,6.4,0,0,1,6.4,6.4v8.9a6.4,6.4,0,0,1-6.4,6.4h-.023a6.4,6.4,0,0,0-6.4,6.4v8.9a6.4,6.4,0,0,0,6.4,6.4h1.4a6.4,6.4,0,0,1,6.4,6.4v8.9a6.4,6.4,0,0,1-6.4,6.4H92.219a6.4,6.4,0,0,0-6.4,6.4v8.9a6.4,6.4,0,0,0,6.4,6.4H272.112a6.4,6.4,0,0,0,6.4-6.4v-8.9a6.4,6.4,0,0,0-6.4-6.4h-5.548a6.4,6.4,0,0,1-6.4-6.4v-8.9a6.4,6.4,0,0,1,6.4-6.4h13.083a6.4,6.4,0,0,0,6.4-6.4v-8.9a6.4,6.4,0,0,0-6.4-6.4h-3.969a6.4,6.4,0,0,1-6.4-6.4v-8.9a6.4,6.4,0,0,1,6.4-6.4h14.874a6.4,6.4,0,0,0,6.4-6.4Z",
    transform: "translate(0 -38.241)",
    fill: "#dbf2ff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    x2: 13.383,
    transform: "translate(164.369 139.991)",
    fill: "none",
    stroke: "#ee781d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    x2: 13.383,
    transform: "translate(164.369 143.849)",
    fill: "none",
    stroke: "#ee781d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_247",
    "data-name": "Line 247",
    x2: 13.383,
    transform: "translate(164.369 147.706)",
    fill: "none",
    stroke: "#ee781d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    x2: 13.383,
    transform: "translate(139.403 73.402)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    x2: 13.383,
    transform: "translate(139.403 77.259)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x2: 13.383,
    transform: "translate(139.403 81.116)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x2: 13.383,
    transform: "translate(259.904 135.273)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    x2: 13.383,
    transform: "translate(259.904 139.13)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x2: 13.383,
    transform: "translate(259.904 142.987)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    x2: 13.382,
    transform: "translate(120.89 193.735)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x2: 13.382,
    transform: "translate(120.89 197.592)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    x2: 13.382,
    transform: "translate(120.89 201.449)",
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 6.806,
    cy: 6.806,
    r: 6.806,
    transform: "translate(116.075 127.241)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 3.545,
    cy: 3.545,
    r: 3.545,
    transform: "translate(121.04 116.728)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 2.045,
    cy: 2.045,
    r: 2.045,
    transform: "translate(135.017 118.605)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 4.902,
    cy: 4.902,
    r: 4.902,
    transform: "translate(133.374 127.095)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 6.806,
    cy: 6.806,
    r: 6.806,
    transform: "translate(246.64 202.741)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1268",
    "data-name": "Ellipse 1268",
    cx: 3.545,
    cy: 3.545,
    r: 3.545,
    transform: "translate(240.384 195.9)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1269",
    "data-name": "Ellipse 1269",
    cx: 2.045,
    cy: 2.045,
    r: 2.045,
    transform: "translate(250.136 188.034)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1270",
    "data-name": "Ellipse 1270",
    cx: 4.902,
    cy: 4.902,
    r: 4.902,
    transform: "translate(256.79 191.484)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1271",
    "data-name": "Ellipse 1271",
    cx: 6.806,
    cy: 6.806,
    r: 6.806,
    transform: "translate(239.832 87.718)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1272",
    "data-name": "Ellipse 1272",
    cx: 3.545,
    cy: 3.545,
    r: 3.545,
    transform: "translate(230.823 80.877)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1273",
    "data-name": "Ellipse 1273",
    cx: 4.902,
    cy: 4.902,
    r: 4.902,
    transform: "translate(242.867 75.974)",
    fill: "#b9d4db"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1274",
    "data-name": "Ellipse 1274",
    cx: 6.806,
    cy: 6.806,
    r: 6.806,
    transform: "translate(163.474 173.773)",
    fill: "#ee781d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1275",
    "data-name": "Ellipse 1275",
    cx: 3.545,
    cy: 3.545,
    r: 3.545,
    transform: "translate(157.217 166.932)",
    fill: "#ee781d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1276",
    "data-name": "Ellipse 1276",
    cx: 2.045,
    cy: 2.045,
    r: 2.045,
    transform: "translate(166.97 159.066)",
    fill: "#ee781d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1277",
    "data-name": "Ellipse 1277",
    cx: 4.902,
    cy: 4.902,
    r: 4.902,
    transform: "translate(173.624 162.515)",
    fill: "#ee781d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94723",
    "data-name": "Path 94723",
    d: "M270.262,99.971c13.915-19.609,22.554-37.38,19.3-39.692l-3.734-2.65c-3.259-2.313-17.182,11.709-31.1,31.317s-22.554,37.379-19.3,39.692l3.734,2.65C242.425,133.6,256.347,119.58,270.262,99.971Z",
    transform: "translate(-83.194 -7.288)",
    fill: "#806dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94730",
    "data-name": "Path 94730",
    d: "M43.536,0C67.581,0,87.073,3.24,87.073,7.236s-19.492,7.236-43.536,7.236S0,11.232,0,7.236,19.492,0,43.536,0Z",
    transform: "matrix(0.579, -0.816, 0.816, 0.579, 146.336, 117.163)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94724",
    "data-name": "Path 94724",
    d: "M281.066,112.92c3.871,2.747-7.532,18.816-11.4,16.069s-4.457-8.571-1.308-13.009S277.195,110.173,281.066,112.92Z",
    transform: "translate(-100.839 -37.523)",
    fill: "#806dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94725",
    "data-name": "Path 94725",
    d: "M237.545,252.6l10.22,89.4h.111c0,3.048,14.867,5.519,33.206,5.519s33.206-2.471,33.206-5.519h.111l10.22-89.4Z",
    transform: "translate(-84.759 -116.345)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1279",
    "data-name": "Ellipse 1279",
    cx: 43.536,
    cy: 7.236,
    rx: 43.536,
    ry: 7.236,
    transform: "translate(152.786 129.021)",
    fill: "#806dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24282",
    "data-name": "Rectangle 24282",
    width: 3.72,
    height: 64.941,
    rx: 1.86,
    transform: "translate(195.695 156.336)",
    fill: "#806dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94726",
    "data-name": "Path 94726",
    d: "M380.141,363.01l-2.352-.325c-.375-.052-.659-.708-.633-1.464l2.111-62.048c.026-.757.351-1.328.726-1.276l2.352.325c.375.052.659.707.633,1.464l-2.111,62.048C380.842,362.491,380.516,363.062,380.141,363.01Z",
    transform: "translate(-162.75 -141.647)",
    fill: "#806dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94727",
    "data-name": "Path 94727",
    d: "M287.374,363.01l2.352-.325c.375-.052.659-.708.633-1.464l-2.111-62.048c-.026-.757-.351-1.328-.726-1.276l-2.352.325c-.375.052-.659.707-.633,1.464l2.111,62.048C286.673,362.491,287,363.062,287.374,363.01Z",
    transform: "translate(-111.009 -141.647)",
    fill: "#806dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94728",
    "data-name": "Path 94728",
    d: "M341.093,173.981l-3.063,10.385-26.477-7.81a1.118,1.118,0,0,1-.756-1.389l12.392-42.012a1.118,1.118,0,0,1,1.389-.756l35.832,10.569a1.119,1.119,0,0,1,.756,1.389l-9.645,32.7Z",
    transform: "translate(-125.654 -49.171)",
    fill: "#2f6572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94729",
    "data-name": "Path 94729",
    d: "M372.558,237.055l3.063-10.385,10.428,3.075Z",
    transform: "translate(-160.182 -101.859)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24283",
    "data-name": "Rectangle 24283",
    width: 13.758,
    height: 6.28,
    transform: "translate(201.281 92.63) rotate(16.433)",
    fill: "#b5aaff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    x2: 10.106,
    y2: 2.981,
    transform: "translate(216.871 100.502)",
    fill: "none",
    stroke: "#b5aaff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    x2: 10.106,
    y2: 2.981,
    transform: "translate(193.671 118.903)",
    fill: "none",
    stroke: "#b5aaff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    x2: 26.585,
    y2: 7.841,
    transform: "translate(198.118 103.352)",
    fill: "none",
    stroke: "#b5aaff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    x2: 26.585,
    y2: 7.841,
    transform: "translate(196.593 108.523)",
    fill: "none",
    stroke: "#b5aaff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    x2: 26.585,
    y2: 7.841,
    transform: "translate(195.068 113.695)",
    fill: "none",
    stroke: "#b5aaff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopup);
export default __webpack_public_path__ + "static/media/DeletePopup.c1beb6a2b59fa1005723b22043419f42.svg";
export { ForwardRef as ReactComponent };